import React from "react";
import { XIcon } from "lucide-react";
import { pains } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function PainSection() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-131" data-mp="2uy5mizx0gxyj">
      <SectionHeading eyebrow="LA RÉALITÉ DE L'ENSEIGNEMENT DE LA GUITARE" title={<>Ça vous <span className="text-gold" data-id="element-133" data-mp="2z1lhzsxcgs9n">ressemble ?</span></>} subtitle="Combien de temps allez-vous encore improviser chaque cours ?" data-id="element-132" data-mp="2v0i2j7j7ky8y" />
      <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-134" data-mp="2pzcc5gd0tn2l">
        {pains.map(p => <li key={p} className="flex gap-3 rounded-xl border border-line bg-ink p-4 text-mute" data-id="element-135" data-mp="2bb7m1rbn299s">
            <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-136" data-mp="2gaaullqtuxmi" />
            {p}
          </li>)}
      </ul>
      <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-lg italic text-cream sm:text-xl" data-id="element-137" data-mp="22a9rs0r05g4e">
        Votre temps devrait servir à enseigner et à changer des vies — pas à rester bloqué derrière un écran à mettre en page des fiches.
      </p>
    </section>;
}